import { useEffect } from 'react';
import { TbSearch, TbX } from 'react-icons/tb';

import { Button } from '@frontend/components/ui/button';
import { Input } from '@frontend/components/ui/input';
import { cn } from '@frontend/lib/utils';

export interface SearchInputProps {
  searching?: boolean;
  onSearch: (q: string) => void;
  searchVal: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SearchInput = function SearchInput({
  searching,
  onSearch,
  searchVal,
  value,
  onChange,
  placeholder = 'Search for keywords, questions…',
}: SearchInputProps) {
  useEffect(() => {
    if (searchVal !== value) {
      onChange(searchVal);
    }
    // Only run when q changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchVal]);

  const isClearButton = value && value === searchVal;

  return (
    <div className="relative">
      <Input
        className={cn(
          'h-auto text-base py-4 pl-5 pr-14',
          'bg-[rgba(254,255,255,0.20)] border-2 border-[#13202D33]',
          'shadow-[0px_4px_4px_0px_rgba(19,32,45,0.04)]',
          'hover:border-[rgba(19,32,45,0.70)]',
          'focus-visible:bg-white focus-visible:border-[rgba(19,32,45,0.70)] focus-visible:ring-0',
        )}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          if (!e.target.value && searchVal) {
            onSearch('');
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            onSearch(value);
          }
        }}
      />
      <div className="absolute top-1/2 -translate-y-1/2 right-2">
        <Button
          aria-label={isClearButton ? 'Clear' : 'Search'}
          size="icon"
          disabled={!value || searching}
          variant="ghost"
          onClick={() => {
            // Clear button
            if (isClearButton) {
              onSearch('');
            } else {
              onSearch(value);
            }
          }}
        >
          {isClearButton ? (
            <TbX className="h-5 w-5" />
          ) : (
            <TbSearch className="h-5 w-5" />
          )}
        </Button>
      </div>
    </div>
  );
};
